/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} LikesInputs */

const en_likes = /** @type {(inputs: LikesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interested`)
};

const de_likes = /** @type {(inputs: LikesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interessiert`)
};

/**
* | output |
* | --- |
* | "Interested" |
*
* @param {LikesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const likes = /** @type {((inputs?: LikesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<LikesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_likes(inputs)
	return de_likes(inputs)
});